import { httpClient } from '@/services/http/httpClient'
import { getQueryParams, type QueryParams } from '@/utils/queryParams'

type GetArticlesParams = {
  query: QueryParams
}

export type Article = {
  tag: {
    name: string
    color: string
  }
  title: string
  articleImage: string
  date: string
  description?: string
  user: {
    name: string
    avatar: string
  }
  link: string
}

export type GetArticlesResponse = {
  articles: Article[]
  pagination: {
    limit: number
    page: number
    pages: number
    total: number
  }
}

export type GetArticlesReturnData = {
  paginate: {
    limit: number
    page: number
    pages: number
    total: number
  }
  articles: Article[]
}

export async function getArticles({
  query,
}: GetArticlesParams): Promise<GetArticlesResponse> {
  const queryParams = getQueryParams(query)

  const { data } = await httpClient.get<GetArticlesReturnData>(
    `/users/videos/articles?${queryParams}`,
  )

  return {
    articles: data.articles,
    pagination: {
      total: data.paginate.total,
      page: data.paginate.page,
      pages: data.paginate.pages,
      limit: data.paginate.limit,
    },
  }
}
